// extracted by mini-css-extract-plugin
export var container = "_qq-0";
export var dotAnimation = "_qq-2";
export var dotsLoading = "_qq-1";